__turbopack_context__.v({
  "EditorNotice": "LGdcka_EditorNotice",
  "EmptyState": "LGdcka_EmptyState",
  "EmptyStateMessage": "LGdcka_EmptyStateMessage",
  "FilterSectionContent": "LGdcka_FilterSectionContent",
  "Filters": "LGdcka_Filters",
  "Footer": "LGdcka_Footer",
  "MapArea": "LGdcka_MapArea",
  "Root": "LGdcka_Root",
  "Swatch": "LGdcka_Swatch",
  "Swatch--Holdings": "LGdcka_Swatch--Holdings",
  "SwatchGlyph": "LGdcka_SwatchGlyph",
  "SwatchIcon": "LGdcka_SwatchIcon",
  "material-symbols-outlined": "LGdcka_material-symbols-outlined",
  "material-symbols-rounded": "LGdcka_material-symbols-rounded",
  "material-symbols-sharp": "LGdcka_material-symbols-sharp",
  "skeleton-loading": "LGdcka_skeleton-loading",
});
